import React, { useState } from "react";
import CustomButton from "../../components/common/CustomButton";
import HeroSection from "../../components/UserComponents/heroSection";
import PageHeader from "../../components/common/PageHeader";
import { useFirstFlightApply } from "../../custom-hooks/queries";
import { toast } from "react-toastify";

const ApplyNowModal = ({ isOpen, onClose }) => {
  const { mutate, isPending } = useFirstFlightApply();

  const [form, setForm] = useState({
    name: "",
    email: "",
    city: "",
    experienceIdea: "",
    reason: "",
  });

  if (!isOpen) return null;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // 🔥 Map payload according to API DTO
    const payload = {
      name: form.name,
      email: form.email,
      city: form.city,
      experienceIdea: form.experienceIdea,
      whyApplying: form.reason,
    };

    mutate(payload, {
      onSuccess: () => {
        toast.success("Application submitted successfully");
        onClose();
      },
      onError: (error) => {
        toast.error(
          error?.response?.data?.message || "Failed to submit application"
        );
      },
    });
  };

  return (
    <div
      className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl w-full max-w-lg p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-lg font-semibold mb-4">
          Apply for First Flight Fund
        </h3>

        <form className="space-y-4" onSubmit={handleSubmit}>
          <input
            name="name"
            placeholder="Name"
            required
            onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2"
          />

          <input
            name="email"
            type="email"
            placeholder="Email"
            required
            onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2"
          />

          <input
            name="city"
            placeholder="City"
            required
            onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2"
          />

          <textarea
            name="experienceIdea"
            placeholder="Experience Idea"
            rows={3}
            required
            onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2"
          />

          <textarea
            name="reason"
            placeholder="Why are you applying?"
            rows={3}
            required
            onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2"
          />

          <div className="flex justify-end gap-3 pt-2">
            <CustomButton
              variant="secondary"
              onClick={onClose}
              disabled={isPending}
            >
              Cancel
            </CustomButton>

            <CustomButton variant="primary" type="submit" loading={isPending}>
              Submit Application
            </CustomButton>
          </div>
        </form>
      </div>
    </div>
  );
};

export default function FirstFlightFund() {
  const [showModal, setShowModal] = useState(false);

  const handleApplySubmit = (data) => {
    // 🔥 API tum baad mein yahan attach kar dena
  };

  return (
    <div>
      <HeroSection
        title="First Flight Fund"
        description="Supporting creators with ideas ready to take off."
        showSearchBar={false}
      />

      <div className="max-w-5xl mx-auto px-4 py-10">
        <PageHeader title="First Flight Fund" />

        <div className="mt-6 space-y-5 text-gray-700 leading-relaxed">
          <p>
            The <strong>First Flight Fund</strong> supports creators with
            thoughtful ideas and real potential to succeed. It exists to help
            people take their next step by providing support to those best
            positioned to build something meaningful.
          </p>
          <p>
            The fund is open to anyone with an experience-based idea. Recipients
            are selected based on readiness, business understanding, and
            alignment with Toucan’s platform.
          </p>
          <p>
            Applicants are invited to share their idea and their business
            experience so far. All applications are reviewed manually, and
            selected creators will be contacted directly.
          </p>
        </div>

        <div className="mt-10">
          <CustomButton onClick={() => setShowModal(true)}>
            Apply Now
          </CustomButton>
        </div>
      </div>

      <ApplyNowModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
}
